import http from '../utils/HttpUtils';

const getAdUsers = async (search: any) => {
  return http.get(`ad/users?word=${search}`);
};

export default {
  getAdUsers,
};
